<ngx-smart-modal identifier="errorMessageModal" (onDataAdded)="dataAdded($event)">
  <h1>Fout</h1>
  <p>{{message}}</p>
</ngx-smart-modal>
